module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-link', {
    staticClass: "preview",
    attrs: {
      "tag": "div",
      "to": ("work" + (_vm.project.path))
    }
  }, [_c('div', {
    staticClass: "preview__image",
    on: {
      "mouseenter": function($event) {
        _vm.activeArrow = true
      },
      "mouseleave": function($event) {
        _vm.activeArrow = false
      }
    }
  }, [_c('hover-show', {
    attrs: {
      "images": [("/static/images/overview" + (_vm.project.path) + ".jpg")],
      "title": _vm.project.title
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "preview__info"
  }, [_c('h2', {
    staticClass: "preview__title",
    on: {
      "mouseenter": function($event) {
        _vm.activeArrow = true
      },
      "mouseleave": function($event) {
        _vm.activeArrow = false
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.project.title)), _c('br'), _c('span', {
    staticClass: "c-light-grey"
  }, [_vm._v(_vm._s(_vm.project.year))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-729b5d59!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/work/Preview.vue
// module id = 393
// module chunks = 2